import { render, staticRenderFns } from "./Product110Page.vue?vue&type=template&id=d2b8ad22"
import script from "./Product110Page.vue?vue&type=script&lang=js"
export * from "./Product110Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports